
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6LMXR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3b3ba4bd2e84139a$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Slovak
var $3b3ba4bd2e84139a$export$2e2bcd8739ae039 = {
    'ptc.pm.collaborators.title': "Va\u0161i spolupracovn\xedci",
    'ptc.pm.error-heading': 'Vyskytla sa chyba',
    'ptc.pm.error-image-alt-text': "Robot sa pokazil. Nieko\u013Eko \u013Eud\xed sa ho teraz usilovne sna\u017E\xed opravi\u0165.",
    'ptc.pm.error-text': "Tieto chyby sledujeme, ale nev\xe1hajte n\xe1s kontaktova\u0165, ak sa v\xe1m probl\xe9m nepodar\xed vyrie\u0161i\u0165 t\xfdm, \u017Ee znova na\u010D\xedtate str\xe1nku.",
    'ptc.pm.people': "\u013Dudia",
    'ptc.pm.start-a-team': "Zalo\u017Ei\u0165 t\xedm",
    'ptc.pm.view-your-profile': "Zobrazi\u0165 v\xe1\u0161 profil",
    'ptc.pm.your-teams.title': "Va\u0161e t\xedmy"
};

});


//# sourceMappingURL=sk.52a5d0a5.js.map
